import React from 'react'
import { StatTableHeader } from './StatTableHeader'
import { StageStatsRow } from './StageStatsRow'
import { formatDecimalHoursToHM } from '../../utils/formatDecimalHoursToHM'
import { TfiTime } from 'react-icons/tfi'
import { IoSettingsOutline } from 'react-icons/io5'

export const TotalStatsTable = (
  {
    totalStatsData
  }
) => {

  const getTotalHours = (decimalHours) => formatDecimalHoursToHM(decimalHours)
  const getTotalPrepareTime = (decimalHours) => formatDecimalHoursToHM(decimalHours)

  const totalStampMethodStat = methods => {
    return methods.map(draw => {
      const totalHours = getTotalHours(draw.drawingTotalStampsByHourlyRate)
      const totalPrepareTime = getTotalHours(draw.drawingTotalPrepareTime)
      const operationsCount = draw.drawingPrepareOperationsCount
      return (
        <div
          className={`grid grid-cols-[72rem_1fr_1fr] mt-[1px] font-medium text-gray-700 text-center text-Regular(14_16) gap-[1px]`}>
          <div className='py-[2.2rem] bg-[#D5E6FF] text-left pl-[4rem]'>{draw.name}</div>
          <div className={`py-[2.2rem] bg-[#ffffff] grid grid-cols-[1fr_1fr] gap-[3rem]`}>
            <div className={`flex justify-end`}>
              {draw.drawingStamps ? draw.drawingStamps.toLocaleString() : '-'}
            </div>
            {totalHours && <div className={`flex items-center gap-[2rem]`}>
              <div className={`flex items-center gap-[0.4rem]`}>
                <TfiTime /> {totalHours}
              </div>
              {( draw.drawingStamps && totalPrepareTime) ?
                <div className={`flex items-center gap-[0.4rem]`}>
                  <IoSettingsOutline /> {totalPrepareTime} ({operationsCount} настр.)
                </div>
                : <div>-</div>
              }
            </div>
            }
          </div>
          <div className={`py-[2.2rem] bg-[#ffffff]`}>{draw.drawingStamps ? draw.drawingQuantity.toLocaleString() : '-'}</div>
        </div>
      )
    })
  }

  const totalStampGroupStat = groups => {
    return groups.map(group => {
      const methodsStats = group.groupMethodsStats || []
      const totalHours = getTotalHours(group.groupTotalStampsByHourlyRate)
      const totalPrepareTime = getTotalPrepareTime(group.groupTotalPrepareTime)
      const operationsCount = group.groupPrepareOperationsCount

      return (
        <div className={`my-[0.5rem]`}>
          <div
            className={`grid grid-cols-[72rem_1fr_1fr] mt-[1px] text-center font-bold text-Regular(14_16) gap-[1px]`}>
            <div className='py-[2.2rem] bg-[#D5E6FF] text-left pl-[2rem]'>{group.groupName}</div>
            <div className={`py-[2.2rem] bg-[#FFFFFF] grid grid-cols-[1fr_1fr] gap-[3rem]`}>
              <div className={`flex justify-end`}>
                {group.groupTotalStamps ? group.groupTotalStamps.toLocaleString() : '-'}
              </div>
              {totalHours && <div className={`flex items-center gap-[2rem]`}>
                <div className={`flex items-center gap-[0.4rem]`}>
                  <TfiTime /> {totalHours}
                </div>
                {(group.groupTotalStamps && totalPrepareTime) ?
                  <div className={`flex items-center gap-[0.4rem]`}>
                    <IoSettingsOutline /> {totalPrepareTime} ({operationsCount} настр.)
                  </div>
                  : <div>-</div>
                }
              </div>
              }
            </div>
            <div className={`py-[2.2rem] bg-[#FFFFFF]`}>{group.groupTotalQuantity ? group.groupTotalQuantity.toLocaleString() : '-'}</div>
          </div>
          {methodsStats && totalStampMethodStat(methodsStats)}
        </div>
      )
    })
  }

  const totalStageStatsRender = totalStatsData.map(stage => {
    const isStampStage = !!stage.drawingsGroupsStats && stage.drawingsGroupsStats.length
    return (
      <div className={`my-[1rem]`}>
        <StageStatsRow key={stage.id} stageData={stage} total/>
        {isStampStage && totalStampGroupStat(stage.drawingsGroupsStats)}
      </div>
    )
  })

  if(!totalStatsData.length) return null
  return (
    <div className={`mt-[3.6rem] relative`}>
      <div className={`text-Regular(24_30) sticky top-[0] bg-Dominant/Dop font-bold pt-[2rem] pb-[1rem]`}>Итого</div>
      <StatTableHeader totalTable/>
      {totalStageStatsRender}
    </div>
  )
}